/** @format */

import React from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/core";

const Loader = () => {
  const override = css`
    display: flex;
    align-items: center;
    justify-content: center;
    border-color: #6460d1;
    margin-top: 20px;
    margin-borrom: 20px;
    height: 70vh;
  `;
  return <BeatLoader css={override} size={10} color={"#6460d1"} />;
};

export default Loader;
